import React, { FC } from "react";

interface Props {
  linkUrl: string;
  imageUrl: string;
  altText: string;
}

const ProductHuntButton: FC<Props> = ({ linkUrl, imageUrl, altText }) => {
  return (
    <a href={linkUrl} target="_blank">
      <img
        src={imageUrl}
        alt={altText}
        style={{ width: "232px", height: "50px" }}
        width="232"
        height="50"
      />
    </a>
  );
};

export default ProductHuntButton;
